import { applyMiddleware, createStore } from 'redux'
import logger from 'redux-logger'
import thunk from 'redux-thunk'

import reducers from "../_reducers"

const middleware = process.env.NODE_ENV === 'development' ? applyMiddleware(thunk,logger) : applyMiddleware(thunk)

export default createStore(reducers, middleware)
